const React = require('react');
const {FormWrapper} = require('../../../../FormHandlers/');

const UserRegistrationFooter = require('../UserRegistrationFooter');

const BankDataFields = require('./components/BankDataFields');
const Disclaimer = require('./components/Disclaimer');

module.exports = () => {
  return (
    <FormWrapper>
      {(formCtx) => (
        <>
          <BankDataFields formCtx={formCtx} />
          <div className="mt28">
            <Disclaimer />
          </div>
          <UserRegistrationFooter
            formCtx={formCtx}
            nextStepsDisabled
          />
        </>
      )}
    </FormWrapper>
  )
}
